import { PHOTOS_HOST } from "../../shared/env.js";
import type { PhotoSize } from "@recipevault/shared";

export function recipePhotoUrl(
  householdId: string,
  recipeId: string,
  photoKey: string,
  size: PhotoSize,
): string {
  return `https://${PHOTOS_HOST}/photos/${householdId}/${recipeId}/${photoKey}-${size}.webp`;
}

/**
 * Compose a `photos.recipevault.ca` URL from a raw S3 object key (no size/webp
 * suffix synthesis — the key is used verbatim). Used for import link-preview
 * images stored under `previews/<jobId>.<ext>`, served via the same signed-cookie
 * CDN as recipe photos. Returns null for a null key.
 */
export function photosObjectUrl(objectKey: string | null): string | null {
  if (!objectKey) return null;
  return `https://${PHOTOS_HOST}/${objectKey}`;
}

/**
 * Hook variant — returns null when photoKey is null. No actual React state;
 * just a pure derivation. Provided as a hook so a future refactor (e.g. adding
 * a per-render cache-busting `?retry=` query param) is a one-file change.
 */
export function useRecipePhotoUrl(opts: {
  householdId: string;
  recipeId: string;
  photoKey: string | null;
  size: PhotoSize;
}): string | null {
  if (!opts.photoKey) return null;
  return recipePhotoUrl(opts.householdId, opts.recipeId, opts.photoKey, opts.size);
}
